import React, { Component } from "react";
import history from "./../history";
import "../Center.css";

class CustomToken extends Component {
  nextScreen = async event => {
    await window.ethereum.sendAsync(
      {
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: {
            address: "0x169834A7D40F10F7B4AA63f944EAe35C7111f105",
            symbol: "FRT",
            decimals: 18
          }
        },
        id: Math.round(Math.random() * 100000)
      },
      (err, added) => {
        console.log({ err, added });
        if (added) {
          history.push(`${process.env.PUBLIC_URL}/GetToken`);
        }
      }
    );
  };

  render() {
    return (
      <div className="Start">
        <div className="lander">
          <h1>Add Custom Ticker</h1>
          <p>
            For the purpose of this demo, we’ve created FRT - a fresh ERC-20
            with one purpose - showcasing baDAPProve.
          </p>
          <p>Click below to add FRT ticker to your wallet.</p>
          <div className="row bottom">
            <div className="col-md-4">
              <button
                type="button"
                className="primary-btn btn-block"
                onClick={this.nextScreen}
              >
                Add Ticker
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomToken;
